import UnderConstruction from '../components/UnderConstruction'

const Art = () => {
    return (
        <UnderConstruction/>
    );
}

export default Art;